import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allNivelesAcademicosAction,
  setActivoNivelesAcademicosAction,
} from './NivelesAcademicosAction';
import FormNivelesAcademicos from './components/FormNivelesAcademicos';
import ListadoNivelesAcademicos from './components/ListadoNivelesAcademicos';

const NivelesAcademicosView = () => {
  const dispatch = Redux.useDispatch();

  const nivelesAcademicosStore = Redux.useSelector(
    (state) => state.nivelesAcademicos,
  );

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoNivelesAcademicosAction(dispatch, null);
            setOpenModalForm(true);
          }}
          green
          mr={2}
        />
        <BotonComponent
          click={async () => {
            await setActivoNivelesAcademicosAction(dispatch, null);
            await allNivelesAcademicosAction(
              dispatch,
              nivelesAcademicosStore.params,
            );
          }}
          disabled={
            nivelesAcademicosStore.loadingAll ||
            nivelesAcademicosStore.all.length === 0
          }
          white
          text={
            nivelesAcademicosStore.loadingAll ? 'Actualizando...' : 'Actualizar'
          }
        />
      </Grid>
      <Grid item md={12}>
        <ListadoNivelesAcademicos
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </Grid>
      <ModalComponent
        id="modalFormNivelesAcademicos"
        title={`${
          nivelesAcademicosStore.activo
            ? `Editar ${nivelesAcademicosStore.activo.nombre}-${nivelesAcademicosStore.activo.nivelAcademico.nivelAcademico.nombre}`
            : 'Nueva sección'
        }`}
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormNivelesAcademicos
          activo={nivelesAcademicosStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default NivelesAcademicosView;
